import ProjectCard from "../PageLayout/ProjectCard";
import ProjectButton from "../Utils/ProjectButton";
import { ProjectType } from "../Utils/ProjectType.ts";
import ProjectHeader from "./ProjectHeader";
import sharedStyles from "./shared.module.css";



export default function FalloutHotels () {


    return (
        <ProjectCard projectName={"Fallout Hotels"} >


            <ProjectHeader title={"FaLLOUt HoTELS"} subTitle={"Great Uni Hack 2021 - Peak.ai First prize winner"} projectType={ProjectType.Code} />

            <p>
                An interactive map of hotel locations and nuclear powerplant locations + explosion radiuses. This can be used to recommend the most vulnerable and dangerous hotels, helping customers expose themselves to more nuclear radiation in the hopes of gaining cool superpowers.
            </p>

            <p>Made for nuclear fallout themed <strong>Great Uni Hack 2021</strong>. We won <strong>first prize</strong> for the <a href="https://peak.ai" target="_blank" rel="norefferrer noopener">Peak.ai</a> challenge. (See project page for more info).</p>
            
            <p>
                Jankily built in <strong>Google Colab</strong> using <strong>Python</strong> - I helped with the <strong>Folium</strong> map visualisation i.e., nuclear danger zone radiuses around major cities. I also built the functions that calculate the number of danger zones based on location.
            </p>

            <div>
                <iframe className={sharedStyles.video} src="https://www.youtube.com/embed/cl_0TXwsTm4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>

            <br />

            <div className={sharedStyles.links}>
                <ProjectButton link="https://devpost.com/software/fallout-hotels" name={"Project Page"} />
                <ProjectButton link="https://github.com/Portman123/Fallout-Hotels" name={"code"} />
            </div>

        </ProjectCard>
    )
}